export const actions = {
    say({ dispatch, state }, { text, cancel = true }) {
        cancel && dispatch('stopSpeaking');
        if (state.accessibility.options.speak && text) {
            const utterance = new SpeechSynthesisUtterance(text);
            speechSynthesis.speak(utterance);
        }
    },
    stopSpeaking(store) {
        speechSynthesis.cancel();
    }
};
